import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const policeDivStartsWith = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/policeDivisionView/namestartswith`,
      search,
    );

    const uniqueItems = (response.data || []).filter(
      (item, index, array) =>
        index === array.findIndex((findItem) => findItem.text === item.text),
    );

    return uniqueItems.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error("Error in policeDivStartsWith:", e);
    return [];
  }
};

export const policeDivisionNameById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/policeDivisionView/name/${id}`,
    );
    return response.data?.data?.[0] || response.data;
  } catch (e) {
    console.error("Error in policeDivisionNameById:", e);
    return null;
  }
};

export const searchPoliceDivision = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/policeDivision/search`,
      data,
    );
    return response.data || [];
  } catch (e) {
    console.error("Error in searchPoliceDivision:", e);
    return [];
  }
};

export const addPoliceDivisionData = async (data) => {
  const response = await gatewayInstance.post(
    `${SERVICE_ENDPOINT.TRANSPORT}/policeDivision`,
    data,
  );
  return response.data;
};

export const updatePoliceDivisionData = async (data) => {
  const response = await gatewayInstance.put(
    `${SERVICE_ENDPOINT.TRANSPORT}/policeDivision`,
    data,
  );
  return response.data;
};

export const getPoliceDivisionDataById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/policeDivision/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error("Error in getPoliceDivisionDataById:", e);
    throw e;
  }
};
